import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';

@Component({
    standalone: false,
    selector: 'particle-pined-hyperlink-cell-viewer',
  templateUrl: './pined-hyperlink-cell-viewer.component.html',
  styleUrls: ['./pined-hyperlink-cell-viewer.component.scss']
})
export class PinedHyperlinkCellViewerComponent implements OnInit, CellComponent {
  fieldDefinition: FieldDefinition;
  item: any;
  icon: string;
  isCustom: boolean;
  tooltipText: {
    header: string,
    content: string
  };
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();

  constructor() {
    this.tooltipText = {
      header: 'This is a default template provided by Orbitax',
      content: 'You can send a survey using this template or create a copy of this template to make edits.'
    };
  }

  ngOnInit() {
    this.icon = 'fal fa-thumbtack';
    if(this.item && this.item.cells["ToolTipContent"] && this.item.cells["ToolTipContent"].value){
      this.tooltipText = {
        header: this.item.cells["TooltipHeader"].displayText,
        content: this.item.cells["ToolTipContent"].displayText
      };
    }
  }

  onClick() {
    this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition});
  }
}
